{
  "name": "gnvert-analyse",
  "version": "2.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o --proxy-config proxy.config.json --configuration=gnvert",
    "start:integration": "ng serve -o --configuration=integration",
    "start:prod": "ng serve -o --configuration=prod",
    "start:local": "ng serve -o --configuration=local",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/gnvert-analyse/stats.json",
    "linter": "ng lint --fix",
    "build": "ng build",
    "build:integration": "ng build --output-hashing=all --configuration=integration,gnvert",
    "build:prod": "ng build --output-hashing=all --configuration=prod,gnvert",
    "build:local": "ng build --configuration=gnvert,local",
    "build:gnvert": "ng build --configuration=gnvert",
    "swagger-gen": "ng-openapi-gen -c ng-swagger-gen-web-secured.json && ng-openapi-gen -c ng-swagger-gen-web-public.json && ng-openapi-gen -c ng-swagger-gen-gnvert-secured.json && ng-openapi-gen -c ng-swagger-gen-gnvert-public.json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e --configuration=integration",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "postbuild": "node postbuild.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.26",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.26",
    "@angular/compiler": "^21.2.26",
    "@angular/core": "^21.2.26",
    "@angular/forms": "^21.2.26",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.26",
    "@angular/router": "^21.2.26",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@primeuix/themes": "^2.0.3",
    "daisy-design-system-front": "file:design-system-package/daisy-design-system-front-3.0.1.tgz",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng-openapi-gen": "^0.53.0",
    "ngx-logger": "^5.0.12",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.10",
    "primeng-sass-theme": "^17.9.0",
    "rxjs": "~7.8.0",
    "simple-crypto-js": "^3.0.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.29",
    "@angular/cli": "^21.2.29",
    "@angular/compiler-cli": "^21.2.26",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.17",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.0"
  }
}
